var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-wrapper',{attrs:{"straight-title":_vm.additionalModuleName,"moduleEnabler":_vm.moduleEnabler,"hasButtons":false},scopedSlots:_vm._u([{key:"postForm",fn:function(){return [_c('admin-tabs-layers',{staticClass:"pt-8",attrs:{"scope":"sewer","cols-attrs":{ lg: 12, xl: 11 },"schema_scope":"sewer","tab-prop":_vm.tab}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }